import React, { useState } from "react";
// import "./LoginPage.css";
import * as onboardingService from '../_services/onboardingService'
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import Loader from '../components/Loader';
import { useUser } from "../context/UserContext";
import { toast } from "react-hot-toast";

const RegisterBusiness = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const {user } = useUser();

  const {productId, planId} = useParams();
  const plan = location.state?.plan || null;

  const [errors, setErrors] = useState({});
  const [acceptTerms, setAcceptTerms] = useState(null);

  const initialFormState = {
      businessName: "",
      physicalAddress: "",
      city: "",
      registrationNumber: "",
      emailAddress: "",
      mobileNumber: "",
      productId: plan?.productId,
      planId: plan?.planId,
  }

  const [formData, setFormData] = useState(initialFormState);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
  
    setLoading(true);
    setValidated(true);
  
    try {
      let result = {};
      if(user) {
        result = await onboardingService.registerWithUser(formData);
      } else {
        result = await onboardingService.registerWithoutUser(formData);
      }
      toast.success(result.message);
      setFormData(initialFormState);       
      setTimeout(() => {
        navigate(`/registration-success`);
      }, 1000);
    } catch (error) {
      toast.error(error.message || `Something went wrong. Please try again.`);
    } finally {
      setLoading(false);
    }
  };
    
    
  return (
    <div className=" pt-lg-5">

      {/* <Loader show={loading} message="Processing, please wait..." /> */}
      
      {
        plan && plan.productId === productId && plan.planId === planId ? (
        <div className="col-md-6 offset-md-3 card">
          <div className="card-header text-center">
            <h3 className="page-title mb-2">
              Register your {plan.slug} <br></br> 
              {plan.productName} {" "} 
              <span className="text-primary">{plan?.planName}</span> 
            </h3>
          </div>
          <div>
          <div className="card-body">
            <div className="logo-container">
              <form method="post" onSubmit={handleSubmit} className="login-form">
                <div className="form-group">
                  <label>Business Name</label>
                  <input
                    type="text"
                    name="businessName"
                    placeholder="Enter business name"
                    value={formData.businessName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Registration Number</label>
                  <input
                    type="text"
                    name="registrationNumber"
                    placeholder="Enter your business registration number"
                    value={formData.registrationNumber}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="row">
                  <div className="col-md-8">
                    <div className="form-group">
                      <label>Physical Address</label>
                      <input
                        type="text"
                        name="physicalAddress"
                        placeholder="Enter your physical address"
                        value={formData.physicalAddress}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>City</label>
                      <input
                        type="text"
                        name="city"
                        placeholder="Enter your full name"
                        value={formData.city}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Email Address</label>
                      <input
                        type="email"
                        name="emailAddress"
                        placeholder="Enter your email"
                        value={formData.emailAddress}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Mobile Number</label>
                      <input
                        type="text"
                        name="mobileNumber"
                        placeholder="Mobile with country code"
                        value={formData.mobileNumber}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                </div>
                {
                  !user && (
                    <>
                      <p className="text-danger">
                        You seem not to be logged in. 
                        If you proceed we will create a primary user account
                        for your business: <br/>
                        Full Name : {formData.businessName} <br/>
                        Email : {formData.emailAddress} <br/>
                        Mobile : {formData.mobileNumber}
                      </p>
                      <p className="">
                        If you want to have register the business in a
                        different primary account you can {" "}
                        <span><a href="/login">Login</a></span>{" "} or {" "} 
                        <span><a href="/register">Sign Up</a></span>
                      </p>
                    </>
                  )
                }

                {
                  formData.businessName && formData.emailAddress && formData.mobileNumber && (
                    <>
                      <label className="flex items-center gap-2">
                        {/* <input 
                          type="checkbox"
                          name="acceptTerms"
                          checked={acceptTerms}
                          onChanged={(e) => setAcceptTerms(e.target.checked)}
                          className="h-4 w-4"
                        /> */}
                        {" "}
                        <span>By registering you consent that you have read and accepted the {" "} 
                          <a href="/terms">Terms of Use</a>,  {" "}
                          <a href="/acceptable-use">Acceptable Use</a>, {" "}
                          <a href="/dpa">Data processing agreement</a>,  {" "}
                          <a href="/cookies">Cookie policy</a>, {" "}
                        </span>
                      </label>
                      <button 
                        type="submit" 
                        className="login-btn" 
                        disabled={loading}
                      >
                        {
                          loading 
                          ? <>
                              <div className="spinner"></div> Processing
                            </>
                          : <>
                              <i className="bi bi-plus-circle"></i> Register
                            </>
                        }
                      </button>
                    </>
                  )
                }

                <p className="register-text">
                  Not Yet Decided{": "}
                  <a href="/products">See products</a>
                </p>
              </form>
            </div>
          </div>
          </div>
        </div>
        ) : (
          <>
          <div className="login-card mt-lg-5 mb-lg-5">
            <div className="logo-container">
            <h3 className="page-title mb-2">Invalid product.</h3>
            <p>Unknown product name. please pick a valid industry in which you business belongs.</p>
              <p className="register-text">
                We have our product here{" "}
                <a href="/products">See products</a>
              </p>
          </div>
        </div>
        </>
        )
      }
    </div>
  );
};

export default RegisterBusiness;